resourcePaths = '{"rootPath":"","assetsPath":""}';/*
// Sample Component
function SampleComponent() { // Name of component (class). Can be referenced in HTML by data-mogo-ui="SampleComponent"
    // Extend classes - An array of Classes that this component should extend - see documentation below for details
    this.extends = [ClassA, ClassB, ...];

    // Attributes (these attributes are reserved and injected into the created instance)
    this.id = null; // ID of created instance of component, automatically generated if one was declared on the HTML node
    this.node = null; // HTML node referencing the node
    this.declaredClass = null; // Class of component (eg. SampleComponent)

    // Additional attributes can be declared as necessary for the component

    // Any initialization code that will run when the instance is created
    this.init = function() {
        this._super(); // Call base class method, if applicable (this class extends another class containing the same method)
    };

    // Any initialization code that will run after the DOM is completely loaded,
    // including any images (this method is useful for calculations of dimensions during initialization)
    this.initAllReady = function() {

    };

    // Additional methods can be declared as necessary for the component
}

// Component declaration initialization
// - All components declared in the HTML are automatically created and initialized on page load
// - Declare components in HTML through data-mogo-ui="SampleComponent"
// - Components declared in HTML can have attributes passed in through data-mogo-ui-attributeName="attributeValue". Attributes declared this way will be automatically
//   injected into the created instance.
// - Components can also be dynamically created (after page load) by calling $(nodeReference).mogo().create("SampleComponent", {"otherAttribute":"otherAttributeValue"});

// Component reference
// - Created instances can be referenced by calling $(nodeReference).mogo(). This will return the JS object of the instance. From there, you can access any
//   methods or variables

// Additional functions
// - mogo.repository() will return a list of all created instances of Mogo components on the page

// Extending Classes and Inheritance
// - One or more classes can be extended by declaring this.extends = [ClassA, ClassB, ...]
// - When multiple classes are extended with the same method name, the method in the first Class in the list is extended, methods with the same name in subsequent
     Classes are not extended
//     - When multiple classes are extended with the same VARIABLE name, the value of the class at the top of the chain will be used
// - You may invoke the method of the base class (parent class) by calling this._super()
*/